import IconSubmit from '@assets/icons/check.svg?react';
import {
 Box,
 Button,
 Dialog,
 DialogContent,
 DialogTitle,
 TextField,
 Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CloseButton from '@/components/common/CloseButton';
import GroupsList from '@/components/adminAccessGroups/GroupsList';
import RolesList from '@/components/adminAccessGroups/RolesList';
import { useAccessGroups } from '@/components/adminAccessGroups/useAccessGroups';
import { setHeaderTitle } from '@/redux/header/headerSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
const AdminAccessGroups = () => {
 const { t } = useTranslation();
 const dispatch = useDispatch();
 const {
  accessGroups,
  selectedGroup,
  selectedGroupId,
  localRoles,
  localRoleIdSet,
  filteredGroupedRoles,
  searchValue,
  modalOpen,
  editingGroup,
  isSubmitting,
  isLoadingRoles,
  isLoadingList,
  isApplyingRoleChanges,
  hasRoleChanges,
  control,
  handleSubmit,
  setSearchValue,
  handleSelectGroup,
  handleRoleToggle,
  handleGroupToggle,
  handleResetRoleChanges,
  handleSaveRoleChanges,
  handleCopyGroup,
  handleOpenCreateModal,
  handleOpenEditModal,
  handleCloseModal,
  handleFormSubmit,
  handleDeleteGroup,
 } = useAccessGroups();

 const handleDeleteSelectedGroup = () => {
  if (!selectedGroup) {
   return;
  }
  handleDeleteGroup(
   selectedGroup,
   t('global.delete'),
   t('global.deleteMessage'),
  );
 };

 const handleEditSelectedGroup = () => {
  if (!selectedGroup) {
   return;
  }
  handleOpenEditModal(selectedGroup);
 };

 useEffect(() => {
  dispatch(setHeaderTitle('Prieigos grupės'));
 }, [dispatch]);

 return (
  <Box sx={{ height: '100%', overflowY: 'visible' }}>
   <Box
    sx={{
     display: 'flex',
     flexDirection: { xs: 'column', md: 'row' },
     height: '100%',
    }}
   >
    <RolesList
     searchValue={searchValue}
     setSearchValue={setSearchValue}
     selectedGroupId={selectedGroupId}
     localRoles={localRoles}
     localRoleIdSet={localRoleIdSet}
     filteredGroupedRoles={filteredGroupedRoles}
     isLoadingRoles={isLoadingRoles}
     handleGroupToggle={handleGroupToggle}
     handleRoleToggle={handleRoleToggle}
    />
    <GroupsList
     accessGroups={accessGroups}
     selectedGroupId={selectedGroupId}
     isLoadingList={isLoadingList}
     isApplyingRoleChanges={isApplyingRoleChanges}
     hasRoleChanges={hasRoleChanges}
     handleSelectGroup={handleSelectGroup}
     handleOpenCreateModal={handleOpenCreateModal}
     handleDeleteGroup={handleDeleteSelectedGroup}
     handleOpenEditModal={handleEditSelectedGroup}
     handleCopyGroup={handleCopyGroup}
     handleResetRoleChanges={handleResetRoleChanges}
     handleSaveRoleChanges={handleSaveRoleChanges}
    />
   </Box>

   <Dialog
    open={modalOpen}
    onClose={handleCloseModal}
    maxWidth="sm"
    sx={{
     '& .MuiDialog-container': {
      '& .MuiPaper-root': {
       maxWidth: { xs: '100%', md: '410px' },
       width: '100%',
      },
     },
    }}
   >
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
     <Typography sx={{ fontSize: 18, fontWeight: 500 }}>
      {editingGroup
       ? t('accessGroups.editGroup')
       : t('accessGroups.createGroup')}
     </Typography>
    </DialogTitle>
    <CloseButton closeDialog={handleCloseModal} />
    <DialogContent sx={{ pt: 0, mb: 2 }}>
     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      <Controller
       name="Name"
       control={control}
       rules={{ required: true }}
       render={({ field }) => (
        <TextField {...field} label={t('global.name')} fullWidth />
       )}
      />
      <Controller
       name="Description"
       control={control}
       render={({ field }) => (
        <TextField
         {...field}
         label={t('accessGroups.description')}
         fullWidth
         multiline
         rows={3}
        />
       )}
      />
     </Box>
     <Box sx={{ pt: 2, display: 'flex', justifyContent: 'flex-end' }}>
      <Button
       type="button"
       onClick={() => handleSubmit(handleFormSubmit)()}
       variant="contained"
       color="primary"
       disabled={isSubmitting}
       endIcon={
        <IconSubmit style={{ color: 'white', width: '16px', height: '11px' }} />
       }
      >
       {editingGroup ? t('global.save') : t('global.create')}
      </Button>
     </Box>
    </DialogContent>
   </Dialog>
  </Box>
 );
};

export default AdminAccessGroups;

